import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import WatchCategoryCreateEditForm from './Components/WatchCategoryCreateEditForm';
import WatchCategoryApi from './WatchCategoryApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: WatchCategoryCreateEditForm,
                getCreate: WatchCategoryApi.create,
                getClone: WatchCategoryApi.getOne,
                defaults: {},
                successMessage: "WatchCategory Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}